export default __webpack_public_path__ + "static/postman-7ed1177fde02430bff1e457822b38dec.svg";